import { useRef } from 'react';

const TestimonialsSection = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const testimonials = [
    {
      id: 1,
      name: 'Ayşe Yılmaz',
      location: 'İzmir, Karşıyaka',
      rating: 5,
      comment: 'İzmir vize danışmanlığı araştırırken Karşıyaka Visa Consulting ile tanıştım. Schengen vizem için tüm süreç çok hızlı ve sorunsuz ilerledi. 12 yıllık deneyimleri gerçekten fark yaratıyor. Teşekkürler!',
      avatar: 'AY',
    },
    {
      id: 2,
      name: 'Mehmet Kaya',
      location: 'İzmir, Bornova',
      rating: 5,
      comment: 'Amerika vizesi başvurumda çok yardımcı oldular. DS-160 formu ve görüşme hazırlığında profesyonel destek aldım. İzmir\'de en iyi vize danışmanlığı hizmeti kesinlikle burada.',
      avatar: 'MK',
    },
    {
      id: 3,
      name: 'Zeynep Demir',
      location: 'İzmir, Alsancak',
      rating: 5,
      comment: 'Oturum kartı başvurumda başından sonuna kadar yanımda oldular. Evrak hazırlığından randevu sürecine kadar her şey mükemmeldi. İzmir vize danışmanlığı için güvenle tavsiye ediyorum.',
      avatar: 'ZD',
    },
    {
      id: 4,
      name: 'Can Özkan',
      location: 'İzmir, Konak',
      rating: 5,
      comment: 'İngiltere turistik vize başvurumda çok titiz ve özenli çalıştılar. Tüm evraklarım eksiksiz hazırlandı ve vizem onaylandı. 12 yıllık tecrübeleri her aşamada hissediliyor.',
      avatar: 'CÖ',
    },
    {
      id: 5,
      name: 'Elif Şahin',
      location: 'İzmir, Çiğli',
      rating: 5,
      comment: 'Aile birleşimi sürecinde inanılmaz destekçi oldular. Karmaşık evrak işlemlerini çok kolay hale getirdiler. İzmir\'deki en profesyonel vize danışmanlığı ekibi.',
      avatar: 'EŞ',
    },
    {
      id: 6,
      name: 'Burak Arslan',
      location: 'İzmir, Buca',
      rating: 5,
      comment: 'E-vize hizmetlerinden yararlandım, çok hızlı ve pratikti. WhatsApp üzerinden sürekli bilgilendirme yaptılar. İzmir vize danışmanlığı için ilk tercihim.',
      avatar: 'BA',
    },
  ];

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 400;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-12 md:py-16 bg-cream-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1.5 md:px-4 md:py-2 bg-navy-100 text-navy-900 text-xs font-semibold tracking-widest uppercase rounded-full mb-3 md:mb-4">
            Müşteri Yorumları
          </span>
          <h2 className="font-display text-2xl md:text-4xl font-bold text-navy-900 mb-3 md:mb-4">
            Müşterilerimiz Ne Diyor?
          </h2>
          <div className="flex items-center justify-center space-x-2 mb-3 md:mb-4">
            <div className="flex space-x-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-lg md:text-xl text-orange-500"></i>
              ))}
            </div>
            <span className="font-display text-xl md:text-2xl font-bold text-navy-900">4.8</span>
            <span className="text-navy-600 text-sm md:text-base">/5.0</span>
          </div>
          <p className="text-navy-600 text-sm md:text-base">
            İzmir vize danışmanlığı hizmetlerimizden yararlanan müşterilerimizin görüşleri
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative">
          {/* Left Fade */}
          <div className="absolute left-0 top-0 bottom-0 w-10 md:w-20 bg-gradient-to-r from-cream-50 to-transparent z-10 pointer-events-none"></div>
          
          {/* Right Fade */}
          <div className="absolute right-0 top-0 bottom-0 w-10 md:w-20 bg-gradient-to-l from-cream-50 to-transparent z-10 pointer-events-none"></div>

          {/* Scroll Container */}
          <div
            ref={scrollRef}
            className="flex space-x-3 md:space-x-6 overflow-x-auto scrollbar-hide pb-4"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="flex-shrink-0 w-[280px] md:w-[380px] bg-white rounded-xl md:rounded-2xl p-5 md:p-7 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                {/* Rating */}
                <div className="flex space-x-1 mb-3 md:mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-base md:text-lg text-orange-500"></i>
                  ))}
                </div>

                {/* Comment */}
                <p className="text-navy-700 italic leading-relaxed mb-4 md:mb-5 text-xs md:text-sm">
                  "{testimonial.comment}"
                </p>

                {/* User Info */}
                <div className="flex items-center space-x-3 pt-3 md:pt-4 border-t border-navy-100">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-navy-900 text-cream-100 rounded-full font-semibold text-sm md:text-base">
                    {testimonial.avatar}
                  </div>
                  <div>
                    <div className="font-semibold text-navy-900 text-sm md:text-base">{testimonial.name}</div>
                    <div className="text-xs md:text-sm text-navy-600">{testimonial.location}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-center space-x-3 md:space-x-4 mt-6 md:mt-8">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-navy-900 text-cream-100 rounded-full hover:bg-navy-800 transition-all hover:scale-110 cursor-pointer"
              aria-label="Önceki"
            >
              <i className="ri-arrow-left-line text-lg md:text-xl"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-navy-900 text-cream-100 rounded-full hover:bg-navy-800 transition-all hover:scale-110 cursor-pointer"
              aria-label="Sonraki"
            >
              <i className="ri-arrow-right-line text-lg md:text-xl"></i>
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
  );
};

export default TestimonialsSection;